import {
    GET_NEW_PT_REPORT_REQUEST,
    GET_NEW_PT_REPORT_SUCCESS,
    GET_NEW_PT_REPORT_ERROR,
  } from "../actions/types";
  
  export const newPTReport = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_NEW_PT_REPORT_REQUEST:
        return {
          loading: true,
        };
      case GET_NEW_PT_REPORT_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_NEW_PT_REPORT_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  